import { StepType, useTour } from '@reactour/tour';
import React from 'react';
import { useSettings } from '../../contexts/SettingsContext';
import { isWidgetMode } from '../../shared/widgets-utils';
import { LearnMoreBox } from './LearnMoreBox';
import { useLocation } from '../../contexts/LocationContext';

export const UITourSteps: StepType[] = [
  {
    selector: '.tour-geolocate-button',
    position: 'right',
    content: 'Click this button to find your current location on the map.',
  },
  {
    selector: '.tour-searchbar',
    position: 'right',
    content: 'Search for any address using this search bar.',
  },
  {
    selector: '#aqMap',
    position: 'center',
    content: 'Click on the map pins to view air quality data at that location.',
  },
  {
    selector: '#aqMap',
    position: 'center',
    content: (
      <div>
        <div>Have a nice day!</div>
        <br />
        <div>
          <LearnMoreBox />
        </div>
      </div>
    ),
  },
];

export const dismissTour = () => {
  localStorage.setItem('wlom:tourDismissed', 'true');
};

interface UITourProps {
  forceTour?: boolean;
}

export const UITour: React.FC<UITourProps> = ({ forceTour = false }) => {
  const { marker } = useSettings();
  const { viewport } = useLocation();
  const [shouldStartTour, setShouldStartTour] = React.useState<boolean>(
    () => localStorage.getItem('wlom:tourDismissed') !== 'true' && !isWidgetMode()
  );
  const { setIsOpen, currentStep } = useTour();
  const delayMs = React.useMemo(() => (forceTour ? 0 : 8_000), [forceTour]);

  // Suppress modal if user has selected a marker
  React.useEffect(() => {
    if (marker) {
      setShouldStartTour(false);
    }
  }, [marker]);

  // Dismiss the modal forever if the user finishes the tour
  React.useEffect(() => {
    if (currentStep === UITourSteps.length - 1) {
      setShouldStartTour(false);
      dismissTour();
    }
  }, [currentStep]);

  // Start timer that opens the modal after some delay
  React.useEffect(() => {
    if (!shouldStartTour && !forceTour) {
      return;
    }

    const timer = setTimeout(() => {
      setIsOpen(true);
    }, delayMs);
    return () => {
      clearTimeout(timer);
    };
  }, [
    delayMs,
    forceTour,
    shouldStartTour,
    setIsOpen,
    viewport /* the tour will only start if the user has not moved the map */,
  ]);

  return <></>;
};
